import classNames from 'classnames/bind';
import { ReactElement } from 'react';
import { EM_DASH } from '../../../Base.constants';
import styles from './NoDataDash.module.scss';

const cx = classNames.bind(styles);

const NoDataDash = (): ReactElement => {
  return <span className={cx('body')}>{EM_DASH}</span>;
};

export default NoDataDash;
